/*
 * azcp-scope-rte-styles.js
 *
 * Many products were imported from eBay and carry a description that embeds an
 * unscoped <style> block (e.g. `html { font-family: ... }`, `.header { ... }`,
 * `.footer { ... }`, `[class*="col-"] { float: left; padding: 15px }`). Those
 * selectors are global, so they leak out of the description and repaint the
 * real site chrome: the product-page header turned red, the footer turned blue,
 * and Dawn's `grid--N-col-*` layout containers got floated (collapsing the
 * product layout and leaving a large blank gap on the right).
 *
 * This rewrites each such <style> block so every selector is prefixed with the
 * description container's scope class — the description still styles ITSELF
 * exactly as before, but it can no longer affect the rest of the page. Runs
 * once on ready; safe on pages with no such blocks (it simply finds nothing).
 *
 * (A static CSS guard in section-main-product.css also neutralises the grid
 * float, so the above-the-fold layout never flashes before this script runs.)
 */
(function () {
  var SCOPE_CLASS = 'azcp-rte-scope';
  var SCOPE = '.' + SCOPE_CLASS;
  var CONTAINERS = '.accordion__content, .product__description, .rte';

  function prefixSelector(selectorText) {
    return selectorText
      .split(',')
      .map(function (sel) {
        sel = sel.trim();
        if (!sel) return sel;
        var first = sel.split(/[\s>+~]/)[0].toLowerCase();
        // html/body/:root can't live inside the scope — retarget their intent
        // onto the scope container itself so the description still gets them.
        if (first === 'html' || first === 'body' || first === ':root') {
          return SCOPE + sel.slice(first.length);
        }
        return SCOPE + ' ' + sel;
      })
      .join(', ');
  }

  function serializeRules(rules) {
    var css = '';
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (rule.type === CSSRule.STYLE_RULE) {
        css += prefixSelector(rule.selectorText) + '{' + rule.style.cssText + '}';
      } else if (rule.type === CSSRule.MEDIA_RULE) {
        css += '@media ' + rule.media.mediaText + '{' + serializeRules(rule.cssRules) + '}';
      } else if (rule.type === CSSRule.SUPPORTS_RULE) {
        css += '@supports ' + rule.conditionText + '{' + serializeRules(rule.cssRules) + '}';
      } else if (rule.cssText) {
        // @font-face, @keyframes, etc. — pass through unchanged.
        css += rule.cssText;
      }
    }
    return css;
  }

  function scopeAll() {
    var styles = document.querySelectorAll(CONTAINERS + ' style:not([data-azcp-scoped])');
    for (var i = 0; i < styles.length; i++) {
      var styleEl = styles[i];
      var sheet = styleEl.sheet;
      if (!sheet) continue;
      var container = styleEl.closest(CONTAINERS);
      if (!container) continue;
      container.classList.add(SCOPE_CLASS);
      var scoped;
      try {
        scoped = serializeRules(sheet.cssRules);
      } catch (e) {
        continue;
      }
      var replacement = document.createElement('style');
      replacement.setAttribute('data-azcp-scoped', '1');
      replacement.textContent = scoped;
      styleEl.replaceWith(replacement);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scopeAll);
  } else {
    scopeAll();
  }
})();
